import { CollaboratorsScope } from 'mormaii-web-presentation/collaborators'
import type { ViewFactory } from 'wdc-cube-solid'

import { CollaboratorsView } from './v-collaborators'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(CollaboratorsScope, CollaboratorsView)
}

export { CollaboratorsView }
